/**
 * Utility function for writing CSS variables
 * @param variableName CSS variable name
 * @returns string with variable definition e.g.: var(--var-name)
 */
export const useCssVar = (variableName: string) => `var(${variableName})`;
